export function billingPortalReturnUrl(creditsTab = "overview") {
  if (typeof window === "undefined") {
    return undefined;
  }

  return `${window.location.origin}/settings?section=credits&creditsTab=${creditsTab}&portalReturn=1`;
}
